import { useState } from "react";
// mui components
import { Box, Switch } from "@mui/material";
//axios
import EnhancedAxios from "../../api/EnhancedAxios";
// redux hooks
import { useSelector } from "react-redux";
// alerts
import { successAlert, errorAlert } from "../../utils/alerts";

const IsResolvedSwitch = ({ id, is_resolved }) => {
    const [value, setValue] = useState(is_resolved);
    const userToken = useSelector((state) => state.userToken);
    const handleChange = (e) => {
        EnhancedAxios("multipart/form-data", userToken)
            .post(`/admin/sos-requests/${id}`)
            .then((response) => {
                const alertMsg = successAlert("تم تغيير حالة طلب المساعدة");
                setValue(response.data.status == "resolved" ? true : false);
            })
            .catch((error) => {
                errorAlert(error);
            });
    };
    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
            }}
        >
            <Switch
                checked={value}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
                // disabled={userData.id === id}
                size="small"
            />
        </Box>
    );
};

export default IsResolvedSwitch;
